import { createContext, useCallback, useEffect, useState } from "react";
import ModalLoginComponent from "src/components/modal-login";
import { IAuth } from "src/interfaces";
import { AuthedServices } from "src/services";

const AuthContext = createContext({});

interface IProps {
  children: React.ReactNode;
}

const AuthContextProvider = ({ children }: IProps) => {
  const [auth, setAuth] = useState<IAuth | undefined>({
    user: undefined,
    access_token: localStorage.getItem("access_token") || "",
    loading: true,
    user_type: localStorage.getItem("user_type") || "",
  });

  const [showPopupLogin, setShowPopupLogin] = useState<boolean>(false);

  const logout = () => {
    localStorage.removeItem("access_token");
    setAuth({
      user: undefined,
      access_token: "",
      loading: true,
      user_type: "",
    });
    window.location.href = "/";
  };

  const fetchProfile = useCallback(async (token: string) => {
    const response = await AuthedServices.getProfile({ param_datas: {} });
    if (response && response.data) {
      setAuth((pre: any) => {
        return {
          ...pre,
          access_token: token,
          user: { ...response.data },
        };
      });
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (token) {
      fetchProfile(token)
        .catch(console.error)
        .finally(() => {
          setAuth((pre: any) => {
            return {
              ...pre,
              loading: false,
            };
          });
        });
    }
  }, [fetchProfile]);

  return (
    <AuthContext.Provider
      value={{ auth, setAuth, showPopupLogin, setShowPopupLogin, logout }}
    >
      {children}
      <ModalLoginComponent />
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthContextProvider };
